import actions from '../../actions/machine-state/feed-rate';
import { handleActions } from 'redux-actions';

const reducer = handleActions(
  {
    [actions.machineState.feedRate.set]: (state, action) => action.payload
  },
  0
);

export default reducer;
